var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '@emotion/styled';
export var Image = styled.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  cursor: pointer;\n  z-index: 999;\n"], ["\n  position: fixed;\n  bottom: 30px;\n  right: 30px;\n  cursor: pointer;\n  z-index: 999;\n"])));
var templateObject_1;
